import { useEffect } from "react";
import NameSelector from "./NameSelector";
import { roofColors, roofs } from "./data/config";

const Roof = ({ selectedRoof, selectRoof, selectedRoofColor, selectRoofColor, model }) => {

    useEffect(() => {
        if(selectedRoof.colors.indexOf(selectedRoofColor.id) === -1) {
            selectRoofColor(roofColors[0]);
        }
    }, [selectedRoof, selectRoofColor, selectedRoofColor])

    const handleSelectRoof = (roof) => () => {
        selectRoof(roof);
        selectRoofColor(roofColors.find(c=>c.id === roof.colors[0]));
    }

    const handleSelectRoofColor = (color) => () => {
        selectRoofColor(color);
    }
    
    return (
        <div>
            <h2 className='section-title'>Roof</h2>
            <h3 className='subsection-title'>Style</h3>
            <div className='flex gap-4 mb-2'>
                {roofs.map((roof) => {
                    return<NameSelector
                        key={roof.name}
                        name={roof.name}
                        onClick={handleSelectRoof(roof)}
                        selected={roof.id === selectedRoof.id}
                    />
                })}
            </div>
            {selectedRoof.id === 'softtop' && model === 110 &&
            <p className="pb-4 text-gray-400 text-center text-sm">*Softtop for 110 is unavaliable in previewer</p>
            }
            <h3 className='subsection-title'>Colour</h3>
            <div className='flex gap-4'>
                {selectedRoof.colors.map((roofColor) => {
                    let color = roofColors.find(c=>c.id === roofColor);
                    if(!color) 
                        color = {
                            id: 'roof-body-color',
                            name: 'Body Color',
                            prefix: 'Body_Color',
                        }
                    return <NameSelector
                        key={roofColor}
                        name={color.name}
                        onClick={handleSelectRoofColor(color)}
                        selected={selectedRoofColor.id === roofColor || (selectRoofColor.id === 'roof-body-color')}
                    />
                })}
        </div>
        </div>
    )
}

export default Roof;